export default __webpack_public_path__ + "static/logo-3-a65378b47e7fbb066d79a77229e0b113.png";